// extracted by mini-css-extract-plugin
module.exports = {"filters":"new-filters_filters__EHa0d","clearAllBtn":"new-filters_clearAllBtn__QBwlO","viewAllBtn":"new-filters_viewAllBtn__7U1_g"};